import * as React from 'react';
import { SVGProps } from 'react';

const OverviewSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      fill='#9395A1'
      d='M14 6H6v8h8V6ZM26 6h-8v8h8V6ZM14 18H6v8h8v-8ZM26 18h-8v8h8v-8Z'
      opacity={0.2}
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M26 18h-8v8h8v-8ZM14 6H6v8h8V6ZM26 6h-8v8h8V6ZM14 18H6v8h8v-8Z'
    />
  </svg>
);

export default OverviewSidebar;
